const MULTIINPUT_SHOW_MORE_TOKENS = {
	key: "MULTIINPUT_SHOW_MORE_TOKENS",
	defaultText: "{0} More",
};

const TEXTAREA_CHARACTERS_LEFT = {
	key: "TEXTAREA_CHARACTERS_LEFT",
	defaultText: "{0} characters remaining",
};

const TEXTAREA_CHARACTERS_EXCEEDED = {
	key: "TEXTAREA_CHARACTERS_EXCEEDED",
	defaultText: "{0} characters over limit",
};

const PANEL_ICON = {
	key: "PANEL_ICON",
	defaultText: "Expand/Collapse",
};

const MESSAGE_STRIP_CLOSE_BUTTON = {
	key: "MESSAGE_STRIP_CLOSE_BUTTON",
	defaultText: "Message Strip Close",
};

export {
	MULTIINPUT_SHOW_MORE_TOKENS,
	TEXTAREA_CHARACTERS_LEFT,
	TEXTAREA_CHARACTERS_EXCEEDED,
	PANEL_ICON,
	MESSAGE_STRIP_CLOSE_BUTTON,
};
